module.exports = function clark(a, b) {
    var i = 0,
        ii = a.length,
        d = 0;
    for (; i < ii; i++) {
        d += Math.sqrt(((a[i] - b[i]) * (a[i] - b[i])) / ((a[i] + b[i]) * (a[i] + b[i])));
    }
    return 2 * d;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-distance/src/distances/clark.js
 ** module id = 63
 ** module chunks = 0
 **/